
export const formAuditLogBookActionTypes = {

    GET_SINGLE_RESTROOM_DETAILS:'GET_SINGLE_RESTROOM_DETAILS',
    GET_SINGLE_RESTROOM_DETAILS_PENDING: 'GET_SINGLE_RESTROOM_DETAILS_PENDING',
    GET_SINGLE_RESTROOM_DETAILS_FULFILLED: "GET_SINGLE_RESTROOM_DETAILS_FULFILLED",   

    ADD_SINGLE_RESTROOM_DETAILS:'ADD_SINGLE_RESTROOM_DETAILS',
    ADD_SINGLE_RESTROOM_DETAILS_PENDING: 'ADD_SINGLE_RESTROOM_DETAILS_PENDING',
    ADD_SINGLE_RESTROOM_DETAILS_FULFILLED: "ADD_SINGLE_RESTROOM_DETAILS_FULFILLED",   
    ADD_SINGLE_RESTROOM_DETAILS_REJECTED:"ADD_SINGLE_RESTROOM_DETAILS_REJECTED",

    EDIT_SINGLE_RESTROOM_DETAILS:'EDIT_SINGLE_RESTROOM_DETAILS',
    EDIT_SINGLE_RESTROOM_DETAILS_PENDING: 'EDIT_SINGLE_RESTROOM_DETAILS_PENDING',
    EDIT_SINGLE_RESTROOM_DETAILS_FULFILLED: "EDIT_SINGLE_RESTROOM_DETAILS_FULFILLED",  
    EDIT_SINGLE_RESTROOM_DETAILS_REJECTED:"EDIT_SINGLE_RESTROOM_DETAILS_REJECTED",

    GET_ALL_RESTROOM_PORTERING:'GET_ALL_RESTROOM_PORTERING',
    GET_ALL_RESTROOM_PORTERING_PENDING: 'GET_ALL_RESTROOM_PORTERING_PENDING',
    GET_ALL_RESTROOM_PORTERING_FULFILLED: "GET_ALL_RESTROOM_PORTERING_FULFILLED",  
    
    RESTROOM_PORTERING_PAGE_CLICKED  : 'RESTROOM_PORTERING_PAGE_CLICKED'
}

